module.exports = __webpack_public_path__ + "img/cast_ic_pitches.33a6df26.svg";